// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-align[data-v-c99dd7b0]{text-align:left}.v-toolbar__content[data-v-c99dd7b0]{background-color:red!important}", ""]);
// Exports
module.exports = exports;
